module.exports = __webpack_public_path__ + "img/edit.cadd1ec6.svg";